import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@reach/router';
import Img from 'gatsby-image';
import * as Styled from './styled';

const getLinkProps = (link = '') => {
  if (link) {
    return link.startsWith('/')
      ? { component: Link, to: link }
      : { component: 'a', href: link, target: "_blank", rel: 'noopener noreferrer' }
  }

  return {};
}

const SubSection = ({
  alt,
  background,
  color,
  children,
  image,
  imgStyle,
  imgWrapperStyle,
  direction,
  link,
  linkText,
  sup,
  text,
  title,
  titleStyle,
  contentStyle,
  wrapperStyle,
  cancelFullWidth,
  imageSvg,
}) => {
  const linkProps = useMemo(() => getLinkProps(link), [link]);
  return (
    <Styled.Wrapper
      background={background}
      direction={direction}
      justify={image ? 'space-around' : 'flex-start'}
      hasimage={Boolean(image) ? 1 : 0}
      style={wrapperStyle}
    >
      <Styled.ContentWrapper
        direction={direction}
        hasimage={Boolean(image) ? 1 : 0}
        style={contentStyle}
      >
        {sup && (
          <Styled.Sup
            variant="subtitle2"
            component="sup"
            color="secondary"
            gutterBottom
          >
            {sup}
          </Styled.Sup>
        )}
        {title &&
          <Styled.Title
            variant="h2"
            color="primary"
            fullwidth={Number(!image) && Number(!cancelFullWidth)}
            style={titleStyle}
            gutterBottom
          >
            {title}
          </Styled.Title>
        }
        {text && (
          <Styled.Text
            variant="body1"
            gutterBottom
            style={{ color }}
          >
            {text}
          </Styled.Text>
        )}
        {children}
        {link && (
          <Styled.Link
            variant="subtitle2"
            color="secondary"
            {...linkProps}
          >
            { linkText || 'Saiba mais >>' }
          </Styled.Link>
        )}
      </Styled.ContentWrapper>

      {image &&
        <Styled.ImageWrapper direction={direction}>
          <Img
            fluid={image}
            alt={alt}
            style={imgWrapperStyle}
            imgStyle={{
              objectFit: 'contain',
              objectPosition: '0 100%',
              width: '100%',
              height: '100%',
              ...imgStyle,
            }}
          />
        </Styled.ImageWrapper>
      }
      {imageSvg &&
       <img src={imageSvg} />
      }
    </Styled.Wrapper>
  );
}

SubSection.propTypes = {
  alt: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element]),
  image: PropTypes.object,
  imageSvg: PropTypes.string,
  imgStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  imgWrapperStyle: PropTypes.object,
  direction: PropTypes.oneOf(['row', 'row-reverse']),
  link: PropTypes.string,
  sup: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.array]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.array]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.array]),
  cancelFullWidth: PropTypes.bool,
};

SubSection.defaultProps = {
  alt: '',
  background: '',
  color: '',
  children: null,
  image: null,
  imageSvg: '',
  imgStyle: {},
  titleStyle: {},
  imgWrapperStyle: {},
  direction: 'row',
  link: '',
  sup: '',
  text: '',
  cancelFullWidth: false,
}

export default memo(SubSection); 